import * as I from "immutable";
import moment from "moment-timezone";
import Raven from "raven-js";
import React, {Component} from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";

import {noop} from "utils";

import api from "v2/api";
import {apiError} from "v2/api/Errors";
import {Route} from "v2/api/Records";
import {apiRoute} from "v2/api/Routes";

import DateFilter from "v2/components/DateFilter";
import Empty from "v2/components/Empty";
import Loading from "v2/components/Loading";
import RoutesGroups from "v2/components/RoutesGroups";
import RoutesSearchBox from "v2/components/RoutesSearchBox";
import ServerError from "v2/components/ServerError";
import StickyFooter from "v2/components/StickyFooter";
import AddRouteLink from "v2/components/responsive/AddRouteLink";

import styles from "v2/styles";

export default class DatePage extends Component {
  static childContextTypes = {
    dateData: ImmutablePropTypes.listOf(Route),
    onUpdateDateData: PropTypes.func,
  }
  static contextTypes = {
    location: PropTypes.object,
    params: PropTypes.shape({
      date: PropTypes.string.isRequired,
    }),
    router: PropTypes.object,
  }
  static propTypes = {
    children: PropTypes.node,
  }

  state = {
    data: I.Map(),
    dataError: I.Map(),
  }

  getChildContext() {
    const {params: {date}} = this.context;
    return {
      dateData: this.state.data.get(date),
      onUpdateDateData: this.loadData,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.loadData();
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const {params: {date}, router} = this.context;
    const {
      location: {pathname: nextPathname, query: nextQuery},
      params: {date: nextDate, routeId: nextRouteId},
    } = nextContext;
    if (date !== nextDate || nextQuery.update) {
      this.loadData(nextContext);

      // Remove `update` from query
      if (nextQuery.update && !nextRouteId) {
        router.push({
          nextPathname,
          query: {
            ...nextQuery,
            update: undefined,
          },
        });
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  apiUrl = "/routes";

  loadData = (context, onLoad) => {
    const {params: {date}} = context || this.context;
    api()
      .get(this.apiUrl, {
        params: {
          date,
          "_": moment().unix(),
        },
      })
      .then((response) => {
        if (!this._isMounted) {
          return;
        }

        this.setState(({data}) => ({
          data: data.set(date, I.List(response.data.map(apiRoute))),
        }), onLoad || noop);
      })
      .catch((err) => {
        if (!this._isMounted) {
          return;
        }

        if (err.response) {
          this.setState(({dataError}) => ({
            dataError: dataError.set(date, apiError(err.response.data)),
          }));
        } else {
          Raven.captureException(err);
        }
      });
  }

  render() {
    const {params: {date}, router} = this.context;

    const data = this.state.data.get(date);
    const dataError = this.state.dataError.get(date);

    let content;
    if (router.isActive(`/${date}`, true)) {
      if (data === undefined && dataError === undefined) {
        content = <Loading />;
      } else if (dataError) {
        content = <ServerError data={data} />;
      } else if (data.isEmpty()) {
        content = <Empty />;
      } else {
        content = (
          <div>
            <RoutesSearchBox />
            <RoutesGroups data={data} />
          </div>
        );
      }
      content = (
        <div>
          {content}
          <StickyFooter>
            <AddRouteLink
              className="col-xs-12 text-center"
              style={{backgroundColor: styles.COLOR.BG_LIGHTGREY}} />
          </StickyFooter>
        </div>
      );
    } else {
      content = this.props.children;
    }

    return (
      <div className="clearfix" style={{marginBottom: "50px"}}>
        <div className="clearfix erg-padding-15" style={{borderBottom: styles.BORDER}}>
          <DateFilter className="pull-left" />
        </div>
        {content}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/v2/pages/DatePage.js
 **/